import { getHeaders } from '@frontend/shared/Util.js';

export async function postSendWizardResultEmail(csrfToken, toSendData) {
  const url = '/api/v1/visitor/send-wizard-email/';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    body: JSON.stringify({
      ...toSendData,
    }),
  });
};


export async function postSendUpdateEmail(feature) {
  const url = '/api/v1/email/upgrade/';

  const response = await fetch(url, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ feature }),
  });
};


export async function postSendInternalEmail(template) {
  const response = await fetch('/api/v1/email/internal/', {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ template }),
  });
};
